(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("workorder-type", {
                parent: "entity",
                url: "/workorder-type",
                data: {
                    authorities:["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-types.html",
                        controller: "WorkOrderTypeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("workorder-type-detail", {
                parent: "workorder-type",
                url: "/workorder-type/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-detail.html",
                        controller: "WorkOrderTypeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrderType",
                        function ($stateParams, WorkOrderType) {
                            return WorkOrderType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "workorder-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("workorder-type.new", {
                parent: "workorder-type",
                url: "/create",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-dialog.html",
                        controller: "WorkOrderTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            createdDate: null,
                            updateDate: null,
                            id: null,
                        };
                    },
                },
            })
            .state("workorder-type.edit", {
                parent: "workorder-type",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-dialog.html",
                        controller: "WorkOrderTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrderType",
                        function ($stateParams, WorkOrderType) {
                            return WorkOrderType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "workorder-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("workorder-type.delete", {
                parent: "workorder-type",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/workorder-type/workorder-type-delete-dialog.html",
                                controller: "WorkOrderTypeDeleteController",
                                controllerAs: "vm",
                                size: "sm",
                                resolve: {
                                    entity: [
                                        "WorkOrderType",
                                        function (WorkOrderType) {
                                            return WorkOrderType.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("workorder-type", null, {
                                        reload: "workorder-type",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();
